'use client'
import * as React from 'react'
import * as TabsComp from 'primitives/tabs'

import { cn } from '@/utils/ui'
import { Text } from './text'

export interface TabProps {
  tabs: { title: string; content: string }[]
  activeTab: string
  setActiveTab: React.Dispatch<React.SetStateAction<string>>
}

export function TabsComponent({ tabs, activeTab, setActiveTab }: TabProps) {
  return (
    <TabsComp.Root defaultValue="0" onValueChange={value => setActiveTab(value)}>
      <TabsComp.List className="mx-auto flex w-full max-w-4xl flex-col pt-16 md:flex-row md:justify-between">
        {tabs.map(({ title }, index) => (
          <div key={title} className="group relative w-full shrink-0 md:w-1/3">
            <TabsComp.Trigger
              value={`${index}`}
              className={cn(
                'text-cool-gray-400 h-12 w-full shrink-0 truncate whitespace-pre-wrap text-[16px] font-medium md:pb-3 md:text-lg',
                {
                  'text-cool-gray-50': activeTab === `${index}`,
                },
              )}
            >
              {title}
            </TabsComp.Trigger>
            <div
              className={cn('absolute inset-x-0 bottom-0 w-full transition-all', {
                'h-0.5 bg-indigo-500 ': activeTab === `${index}`,
                'bg-cool-gray-600 h-px group-hover:bg-indigo-800': activeTab !== `${index}`,
              })}
            />
          </div>
        ))}
      </TabsComp.List>
      <TabsComp.Content value={activeTab}>
        <Text
          variant="p"
          className="text-16 text-cool-gray-300 mx-auto min-h-60 max-w-4xl whitespace-pre-wrap pt-6 text-center md:min-h-40"
        >
          {tabs[Number(activeTab || 0)].content}
        </Text>
      </TabsComp.Content>
    </TabsComp.Root>
  )
}

export function Tabs({ tabs }: Pick<TabProps, 'tabs'>) {
  const [activeTab, setActiveTab] = React.useState<string>('0')

  return <TabsComponent tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
}
